import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    alert('Thank you for your message! We\'ll get back to you soon.');
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
  };

  return (
    <div className="page">
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <img 
            src={`${process.env.PUBLIC_URL}/icon.png`}
            alt="HeyGerman Logo" 
            style={{ 
              width: '60px', 
              height: '60px', 
              borderRadius: '50%',
              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
              marginBottom: '20px'
            }} 
          />
        </div>
        <h1 style={{ textAlign: 'center', marginBottom: '40px', color: '#333' }}>
          Contact Us
        </h1>
        
        <p style={{ textAlign: 'center', fontSize: '1.1rem', color: '#666', marginBottom: '50px', maxWidth: '600px', margin: '0 auto 50px' }}>
          Have questions about HeyGerman? We'd love to hear from you. Send us a message and we'll respond as soon as possible.
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '60px', maxWidth: '1000px', margin: '0 auto' }}>
          {/* Contact Form */}
          <div>
            <h2 style={{ color: '#667eea', marginBottom: '30px' }}>Send us a Message</h2>
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '20px' }}>
                <label htmlFor="name" style={{ display: 'block', marginBottom: '8px', color: '#333', fontWeight: '500' }}>
                  Name *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #ddd',
                    borderRadius: '5px',
                    fontSize: '1rem',
                    transition: 'border-color 0.3s ease'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#667eea'}
                  onBlur={(e) => e.target.style.borderColor = '#ddd'}
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label htmlFor="email" style={{ display: 'block', marginBottom: '8px', color: '#333', fontWeight: '500' }}>
                  Email *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #ddd',
                    borderRadius: '5px',
                    fontSize: '1rem',
                    transition: 'border-color 0.3s ease'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#667eea'}
                  onBlur={(e) => e.target.style.borderColor = '#ddd'}
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label htmlFor="subject" style={{ display: 'block', marginBottom: '8px', color: '#333', fontWeight: '500' }}>
                  Subject *
                </label>
                <select
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #ddd',
                    borderRadius: '5px',
                    fontSize: '1rem',
                    backgroundColor: 'white',
                    transition: 'border-color 0.3s ease'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#667eea'}
                  onBlur={(e) => e.target.style.borderColor = '#ddd'}
                >
                  <option value="">Select a subject</option>
                  <option value="general">General Inquiry</option>
                  <option value="technical">Technical Support</option>
                  <option value="billing">Billing Question</option>
                  <option value="feedback">Feedback</option>
                  <option value="partnership">Partnership</option>
                </select>
              </div>

              <div style={{ marginBottom: '30px' }}>
                <label htmlFor="message" style={{ display: 'block', marginBottom: '8px', color: '#333', fontWeight: '500' }}>
                  Message *
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={6}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #ddd',
                    borderRadius: '5px',
                    fontSize: '1rem',
                    resize: 'vertical',
                    fontFamily: 'inherit',
                    transition: 'border-color 0.3s ease'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#667eea'}
                  onBlur={(e) => e.target.style.borderColor = '#ddd'}
                  placeholder="Tell us how we can help you..."
                />
              </div>

              <button type="submit" className="btn" style={{ width: '100%', padding: '15px' }}>
                Send Message
              </button>
            </form>
          </div>

          {/* Contact Information */}
          <div>
            <h2 style={{ color: '#667eea', marginBottom: '30px' }}>Get in Touch</h2>
            
            <div style={{ marginBottom: '30px' }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                <div style={{ width: '50px', height: '50px', backgroundColor: '#667eea', borderRadius: '50%', 
                             display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '15px' }}>
                  <span style={{ color: 'white', fontSize: '20px' }}>📧</span>
                </div>
                <div>
                  <h4 style={{ margin: 0, color: '#333' }}>Email</h4>
                  <p style={{ margin: '5px 0 0 0', color: '#666' }}>pawankumar@babycode.org</p>
                </div>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                <div style={{ width: '50px', height: '50px', backgroundColor: '#667eea', borderRadius: '50%', 
                             display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '15px' }}>
                  <span style={{ color: 'white', fontSize: '20px' }}>📱</span>
                </div>
                <div>
                  <h4 style={{ margin: 0, color: '#333' }}>Phone</h4>
                  <p style={{ margin: '5px 0 0 0', color: '#666' }}>+919030870876</p>
                </div>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                <div style={{ width: '50px', height: '50px', backgroundColor: '#667eea', borderRadius: '50%', 
                             display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '15px' }}>
                  <span style={{ color: 'white', fontSize: '20px' }}>📍</span>
                </div>
                <div>
                  <h4 style={{ margin: 0, color: '#333' }}>Address</h4>
                  <p style={{ margin: '5px 0 0 0', color: '#666' }}>
                    91springboard, F948+W7, Kondapur<br />
                    Laxmi Cyber City, Whitefields<br />
                    HITEC City, Hyderabad<br />
                    Telangana 500084
                  </p>
                </div>
              </div>
            </div>

            <div style={{ padding: '30px', backgroundColor: '#f8f9fa', borderRadius: '10px' }}>
              <h3 style={{ color: '#333', marginBottom: '15px' }}>Office Hours</h3>
              <div style={{ color: '#666' }}>
                <p style={{ margin: '8px 0' }}>Monday - Friday: 9:00 AM - 6:00 PM</p>
                <p style={{ margin: '8px 0' }}>Saturday: 10:00 AM - 4:00 PM</p>
                <p style={{ margin: '8px 0' }}>Sunday: Closed</p>
              </div>
              <p style={{ marginTop: '20px', color: '#555', fontSize: '0.9rem' }}>
                We aim to respond to all inquiries within 24 hours during business days.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;